export enum ProgressBarVariant {
  DEFAULT = "default",
  UPLOADING = "uploading",
}

export enum ProgressBarTheme {
  LIGHT = "light",
  DARK = "dark",
  SCRIPT_V2 = "script-v2",
}
